
import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Typography,
    Box,
    IconButton,
} from "@material-ui/core";
import Header from './components/Header'
import Footer from './components/Footer'
import { clsx } from 'clsx';
import { ContainedButton } from "./components/elements/Buttons";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CustomInput from "./components/elements/Input";
import Phone from "./images/phone.png";
import Phone2 from "./images/phone2.png";
import Star from "./images/star.svg";
import background from "./images/background.png";
import { ChevronLeft, ChevronRight } from "lucide-react";

const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: "Roboto, Arial, sans-serif",
        backgroundColor: '#0a0a0a',
        color: '#ffffff',
        minHeight: '100vh',
        overflowX: 'hidden',
        lineHeight: "100%"
    },

    section: {
        maxWidth: "1080px",
        margin: "0 auto",
        padding: "60px 0",
        textAlign: "center",
        [theme.breakpoints.down('sm')]: {
            padding: "36px 21px",
        },
    },
    sectionTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "64px",
        fontWeight: 400,
        lineHeight: 1,
        textAlign: "left",
        [theme.breakpoints.down('sm')]: {
            fontSize: '36px',
        },
    },
    sectionText: {
        fontSize: '18px',
        opacity: 0.7,
        lineHeight: 1.4,
        fontWeight: 200,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },

    // Hero Section
    heroRoot: {
        marginTop: "88px",
        position: "relative",
        maxWidth: "100%",
        margin: "0 70px"
    },
    heroContent: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "20px",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            textAlign: "center",
        },
    },
    heroTextContent: {
        flex: 1,
        maxWidth: 750,
        textAlign: "left"
    },
    heroHeadline: {
        fontFamily: '"Cormorant Garamond", serif',
        fontWeight: 400,
        fontSize: "40px",
        lineHeight: 1,
        [theme.breakpoints.down("sm")]: {
            fontSize: "2.5rem",
        },
    },
    heroTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontWeight: 400,
        lineHeight: 1,
        fontSize: "70px",
        marginBottom: "24px"
    },
    exclusiveTier: {
        fontStyle: "italic",
    },
    heroSubtitle: {
        fontSize: "20px",
        color: "#FFFFFF",
        fontWeight: 200,
        marginBottom: "40px",
        lineHeight: 1.4,
        opacity: 0.7,
        maxWidth: "597px"
    },
    primaryButton: {
        fontSize: 20,
        lineHeight: 1,
        fontWeight: 400,
        width: "max-content"
    },
    heroImageContainer: {
        width: "530px",
        margin: "0 auto",
        "& .slick-slider": {
            maxWidth: "530px",
        },

        // базовий стан усіх слайдів
        "& .slick-slide": {
            transition: "all 0.3s ease",
            opacity: 0.4,
            transform: "scale(0.7)",
        },
        "& .slick-slide > div": {
            transition: "transform 0.3s ease, opacity 0.3s ease",
            opacity: 0.6,
            transform: "scale(0.7)",
        },

        // center slide
        "& .slick-center": {
            opacity: 1,
            zIndex: 2,
            transform: "scale(1)",
            height: "100%",
        },
        "& .slick-center > div": {
            transform: "scale(1)",
            opacity: 1,
            position: "relative",
            zIndex: 2,
        },

        // right slide
        "& .slick-center + .slick-slide": {
            transform: "scale(1) translateX(-65%)",
            opacity: 0.7,
        },

        // left slide
        "& .slick-slide:has(+ .slick-center)": {
            transform: "scale(1) translateX(65%)",
            opacity: 0.7,
        },
    },
    heroImage: {
        width: "100%",
        maxWidth: 300,
        maxHeight: 360,
        height: "auto",
        borderRadius: 8,
        objectFit: "cover",
    },
    acceptingText: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "18px",
        fontStyle: "italic",
        background: "linear-gradient(90deg, #CE949C, #E6B1BD, #FFD0E1, #CE949C)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        backgroundClip: "text",         /* for Firefox */
        color: "transparent",
        marginTop: "16px",
        [theme.breakpoints.down("md")]: {
            textAlign: "center",
        },
    },

    // Inner Circle Section
    innerCircleRoot: {
        textAlign: "left"
    },
    innerCircleContent: {
        display: "flex",
        gap: 20,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
        },
    },
    innerCircleTitle: {
        marginBottom: "48px",
    },
    leftColumn: {
        flex: 1,
        maxWidth: 550,
        textAlign: "left",
        margin: "0 0 auto 0"
    },
    rightColumn: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: 48,
        textAlign: "left"
    },
    feature: {
        marginRight: 54
    },
    featureTitle: {
        fontFamily: '"Cormorant Garamond", serif',
        fontSize: "32px",
        fontWeight: 500,
        color: "#FFD0E1",
        marginBottom: "12px",
        lineHeight: "100%"
    },
    featureDesc: {
        fontSize: "16px",
        fontWeight: 300,
        lineHeight: 1.2,
    },
    formCard: {
        backgroundColor: "#1B1B1B",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingBottom: "32px",
    },
    formCardContainer: {
        padding: "32px 45px 0",
    },
    formInputs: {
        width: "100%",
        display: "grid",
        gap: 20,
        marginBottom: 32,
        padding: "0 9.5px"
    },
    seatsText: {
        fontSize: "24px",
        marginBottom: "24px",
        fontWeight: 500,
        letterSpacing: "5%",
        lineHeight: 1.4
    },
    seatsHighlight: {
        background: "linear-gradient(90deg, #CF819D, #FFB8D1, #CF819D)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        backgroundClip: "text",         /* for Firefox */
    },
    priorityNote: {
        fontSize: "18px",
        fontStyle: "italic",
        marginTop: "32px",
        textAlign: "center",
        fontWeight: 200,
        opacity: 0.7,
        letterSpacing: 0,
        lineHeight: 1.4
    },

    // Flawless Experience Section
    flawlessContent: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        marginBottom: 54,
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
        },
    },
    flawlessTitle: {
        marginBottom: 40
    },
    byDesign: {
        fontStyle: "italic",
    },
    featureList: {
        margin: "20px 0 40px",
        display: "grid",
        gap: 12
    },
    featureItem: {
        display: "flex",
        alignItems: "center",
        gap: 8,
    },
    phoneImage: {
        width: "100%",
        height: "auto",
        maxHeight: 732
    },
    rightColumnCenter: {
        position: "absolute",
        top: "-60px",
        right: "-173px",
    },

    // Money Section
    moneyContent: {
        display: "flex",
        gap: theme.spacing(8),
        alignItems: "flex-start",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
        },
    },
    moneySectionText: {
        padding: "22.5px 0",
    },
    leftColumnWithPhone: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "48px",
    },
    phoneContainer: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
    },
    featuresList: {
        display: "flex",
        flexDirection: "column",
        gap: 32
    },

    // Belong Section
    belongContent: {
        display: "flex",
        padding: "80px 0",
        gap: 22,
        alignItems: "center",
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
        },
    },
    imageGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "20px",
        width: "100%",
    },
    gridImage: {
        width: "100%",
        height: "400px",
        // aspectRatio: "3/4",
        objectFit: "cover",
    },

    // Testimonial Section
    testimonialContent: {
        display: "flex",
        gap: "58px",
        alignItems: "center",
        padding: "80px 0",
        "& .slick-slider": {
            width: "100%"
        },
        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
        },
    },
    testimonialContainer: {
        display: "flex !important",
        gap: 58,
    },
    avatarSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "25px",
        textAlign: "left",
        maxWidth: 310,
        marginLeft: 1
    },
    avatar: {
        width: 310,
        height: 265,
        objectFit: "cover",
    },
    creatorName: {
        fontSize: "24px",
        fontWeight: 400,
        lineHeight: 1.4,
    },
    creatorTitle: {
        fontSize: "16px",
        fontWeight: 300,
    },
    quoteSection: {
        flex: 1,
        margin: "0 0 auto 0"
    },
    quote: {
        fontFamily: '"Baskervville", serif',
        fontSize: "40px",
        fontStyle: "italic",
        fontWeight: 400,
        lineHeight: 1.2,
        marginBottom: "41px",
        textAlign: "left",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.5rem",
        },
    },
    navigation: {
        display: "flex",
        gap: theme.spacing(1),
    },
    navButton: {
        color: "#A3A3A3",
        "&:hover": {
            borderColor: "#d4a5a5",
            backgroundColor: "rgba(212,165,165,0.1)",
        },
    },

    // CTA Section
    ctaRoot: {
        backgroundImage: `url(${background})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        position: 'relative',
        "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
            backgroundImage: "inherit",
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "grayscale(100%) brightness(0.3)",
        },

    },
    ctaContent: {
        padding: " 80px 0",
        zIndex: 2,
        position: 'relative'
    },
    ctaHeadline: {
        fontFamily: '"Baskervville", serif',
        fontSize: "64px",
        fontWeight: 400,
        lineHeight: 1,
        marginBottom: "24px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "1.8rem",
        },
    },
    ctaSubtitle: {
        fontSize: "20px",
        fontWeight: 200,
        lineHeight: 1.4,
        marginBottom: "48px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        maxWidth: 547,
        margin: "0 auto",
    },
    submitButtom: {
        margin: "0 auto",
        minWidth: 418,
        marginTop: 32
    }
})
);

const testimonials = [
    {
        quote: `"I didn't want a million subscribers paying $5. I wanted my top 500 VIPs paying for absolute exclusivity. SugarCribs built the exact platform I needed."`,
        name: "Genesis Creator 012",
        title: "(Top 0.1% Earner)",
        avatar:
            "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
    },
    {
        quote: `"Finally a platform that treats my content like the luxury product it is. My conversion rates tripled within the first month."`,
        name: "Genesis Creator 027",
        title: "(Fashion & Lifestyle)",
        avatar:
            "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop",
    },
];

const flawlessFeatures = [
    "Clean UX",
    "Lightning-fast Vault loading",
    "Seamless integrated tipping",
];

const features = [
    {
        title: "The VIP Revenue Split:",
        desc: "Keep a permanently higher percentage of your earnings for your first 6 months.",
    },
    {
        title: "Priority Discovery:",
        desc: "When the members flood in, your profile is pinned to the top of the platform.",
    },
    {
        title: "White-Glove Support:",
        desc: "Get a direct, private line to a dedicated account manager. No automated bot replies, ever.",
    },
];

const moneyFeatures = [
    {
        title: "Tiered VIP Subscriptions:",
        description: "Total control over your monthly pricing structure.",
    },
    {
        title: "The Vault (PPV):",
        description:
            "Sell your premium content directly to high-intent buyers—no algorithms required.",
    },
    {
        title: "Bespoke Requests:",
        description:
            "Seamlessly manage, price, and deliver high-value custom video requests.",
    },
    {
        title: "Ironclad Privacy:",
        description:
            "Strict member identity verification keeps out the time-wasters, lurkers, and bots. Only verified members get access to you.",
    },
];

export default function CreatorsLandingPage() {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [testimonialIndex, setTestimonialIndex] = useState(0);
    const sliderSettings = {
        initialSlide: 1,
        centerMode: true,
        centerPadding: "40px",  // left/right indents (determines how visible adjacent slides are)
        slidesToShow: 1,
        infinite: true,
        speed: 500,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    };
    let testiMonialSSliderRef = React.useRef<Slider | null>(null);

    const testiMonialSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
    };

    return (
        <Box className={classes.root}>
            <Header />
            <>
                {/* Hero Section */}
                <section className={clsx(classes.section, classes.heroRoot)}>
                    <Box className={classes.heroContent}>
                        <Box className={classes.heroTextContent}>
                            <Typography variant="h3" className={classes.heroHeadline}>
                                The era of crowded platforms is over.
                            </Typography>
                            <br />
                            <Typography variant="h1" className={classes.heroTitle}>
                                Step into the{" "}
                                <span className={classes.exclusiveTier}>exclusive tier.</span>
                            </Typography>
                            <Typography className={classes.heroSubtitle}>
                                Mainstream platforms are a race to the bottom.
                                <br />
                                SugarCribs is the invite-only, luxury stage built strictly for
                                premium creators who demand better positioning, elite privacy,
                                and high-value members.
                            </Typography>
                            <ContainedButton text="Apply for Genesis Status" styles={classes.primaryButton} />
                        </Box>
                        <Box className={classes.heroImageContainer}>
                            <Slider {...sliderSettings}>
                                <img
                                    src="https://img.magnific.com/premium-photo/photo-studio-with-professional-equipment-bts-production-set-scenes-model-posing_647822-1239.jpg?w=2000"
                                    alt="Creator left"
                                    className={classes.heroImage}
                                />
                                <img
                                    src="https://img.magnific.com/premium-photo/photo-studio-with-professional-equipment-bts-production-set-scenes-model-posing_647822-1239.jpg?w=2000"
                                    alt="Creator left"
                                    className={classes.heroImage}
                                />
                                <img
                                    src="https://img.magnific.com/premium-photo/photo-studio-with-professional-equipment-bts-production-set-scenes-model-posing_647822-1239.jpg?w=2000"
                                    alt="Creator left"
                                    className={classes.heroImage}
                                />
                            </Slider>
                            <Typography className={classes.acceptingText}>
                                Currently accepting applications for our founding 100 Genesis
                                Creators.
                            </Typography>
                        </Box>
                    </Box>
                </section>

                {/* Inner Circle Section */}
                <section className={clsx(classes.section, classes.innerCircleRoot)}>
                    <Box className={classes.innerCircleContent}>
                        <Box className={classes.leftColumn}>
                            <Typography variant="h2" className={clsx(classes.sectionTitle, classes.innerCircleTitle)}>
                                The inner circle is
                                <br />
                                closing.
                            </Typography>
                            <Box className={classes.featuresList}>
                                {features.map((feature) => (
                                    <Box key={feature.title} className={classes.feature}>
                                        <Typography variant="h5" className={classes.featureTitle}>
                                            {feature.title}
                                        </Typography>
                                        <Typography className={classes.featureDesc}>
                                            {feature.desc}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>

                        </Box>
                        <Box className={classes.rightColumn}>
                            <Typography className={classes.sectionText}>
                                {`We are quietly onboarding exactly 100 "Genesis Creators" to anchor
                the platform before we grant access to our high-net-worth member
                waitlist. Once these 100 spots are filled, the permanent founding
                perks are gone forever.`}
                            </Typography>
                            <Box className={classes.formCard}>
                                <Box className={classes.formCardContainer}>
                                    <Typography className={classes.seatsText}>
                                        <span className={classes.seatsHighlight}>12/100</span> PRIORITY
                                        SEATS REMAINING
                                    </Typography>
                                    <Box className={classes.formInputs}>
                                        <CustomInput value={email} setValue={(val) => setEmail(val)} type="email" placeholder="Enter your best email..." />
                                        <CustomInput value={name} setValue={(val) => setName(val)} type="text" placeholder="How we can address you?" />
                                    </Box>
                                    <ContainedButton text=" Claim Your Spot Before It Closes" styles={classes.primaryButton} />
                                </Box>
                                <Typography className={classes.priorityNote}>
                                    Priority seats are allocated on a first-come, manually-reviewed
                                    basis.
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </section>

                {/* Flawless Experience Section */}
                <section className={clsx(classes.section, classes.flawlessContent)}>
                    <Box className={classes.leftColumn}>
                        <Typography variant="h2" className={clsx(classes.sectionTitle, classes.flawlessTitle)}>
                            A flawless experience,
                            <br />
                            <span className={classes.byDesign}>by design.</span>
                        </Typography>
                        <Typography className={classes.sectionText}>
                            Your content is a luxury product. It shouldn&apos;t be hosted on
                            a platform that looks like a cheap cam site. SugarCribs provides
                            a stunning, high-converting interface designed to make your VIPs
                            feel like they are inside a private club.
                        </Typography>
                        <Box className={classes.featureList}>
                            {flawlessFeatures.map((feature) => (
                                <Box key={feature} className={classes.featureItem}>
                                    <img src={Star} alt="list-icon" />
                                    <Typography className={classes.sectionText}>
                                        {feature}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        <ContainedButton text=" Claim Your Spot Before It Closes" styles={classes.primaryButton} />
                    </Box>
                    <Box className={classes.rightColumnCenter}>
                        <img
                            src={Phone}
                            alt="App interface preview"
                            className={classes.phoneImage}
                        />
                    </Box>
                </section>

                {/* Money Section */}
                <section className={clsx(classes.section, classes.moneyContent)}>
                    <Box className={classes.leftColumnWithPhone}>
                        <Typography variant="h2" className={classes.sectionTitle}>
                            Stop <span className={classes.byDesign}>leaving</span> money
                            <br />
                            on the table.
                        </Typography>
                        <Box className={classes.phoneContainer}>
                            <img
                                src={Phone2}
                                alt="Earnings dashboard preview"
                            />
                        </Box>
                    </Box>
                    <Box className={classes.rightColumn}>
                        <Typography className={clsx(classes.sectionText, classes.moneySectionText)}>
                            You are a business. SugarCribs gives you the multi-stream
                            revenue tools to act like one, fully protected by the strictest
                            privacy standards in the industry.
                        </Typography>
                        <Box className={classes.featuresList}>
                            {moneyFeatures.map((feature) => (
                                <Box key={feature.title} className={classes.feature}>
                                    <Typography variant="h5" className={classes.featureTitle}>
                                        {feature.title}
                                    </Typography>
                                    <Typography className={classes.featureDesc}>
                                        {feature.description}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                    </Box>
                </section>

                {/* Belong Section */}
                <section className={clsx(classes.section, classes.belongContent)}>
                    <Box className={classes.leftColumn}>
                        <Typography variant="h2" className={classes.sectionTitle}>
                            You belong
                            <br />
                            <span className={classes.byDesign}>in the inner circle.</span>
                        </Typography>
                    </Box>
                    <Box className={classes.rightColumn}>
                        <Typography className={classes.sectionText}>
                            {`You've spent years building your brand. Don't dilute it by
                placing your content next to a million amateurs. Move your VIPs
                to a platform that matches your aesthetic and respects your
                worth.`}
                        </Typography>

                        <ContainedButton text="Claim Your Spot Before It Closes" styles={classes.primaryButton} />

                        <Box className={classes.imageGrid}>
                            <img
                                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=200&h=280&fit=crop"
                                alt="Creator portrait 1"
                                className={classes.gridImage}
                            />
                            <img
                                src="https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=200&h=280&fit=crop"
                                alt="Creator portrait 2"
                                className={classes.gridImage}
                            />
                        </Box>
                    </Box>
                </section>

                {/* Testimonial Section */}
                <section className={clsx(classes.section, classes.testimonialContent)}>
                    <Slider ref={testiMonialSSliderRef} {...testiMonialSettings}>
                        {testimonials.map((t) => (
                            <Box key={t.name} className={classes.testimonialContainer}>
                                <Box className={classes.avatarSection}>
                                    <img
                                        src={t.avatar}
                                        alt={t.name}
                                        className={classes.avatar}
                                    />
                                    <Box>
                                        <Typography className={classes.creatorName}>
                                            {t.name}
                                        </Typography>
                                        <Typography className={classes.creatorTitle}>
                                            {t.title}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box className={classes.quoteSection}>
                                    <Typography className={classes.quote}>
                                        {t.quote}
                                    </Typography>
                                    <Box className={classes.navigation}>
                                        <IconButton
                                            className={classes.navButton}
                                            onClick={() => testiMonialSSliderRef.current?.slickPrev()}
                                            aria-label="Previous testimonial"
                                        >
                                            <ChevronLeft color="#A3A3A3" />
                                        </IconButton>
                                        <IconButton
                                            className={classes.navButton}
                                            onClick={() => testiMonialSSliderRef.current?.slickNext()}
                                            aria-label="Next testimonial"
                                        >
                                            <ChevronRight color="#A3A3A3" />
                                        </IconButton>
                                    </Box>
                                </Box>
                            </Box>
                        ))}
                    </Slider>
                </section>

                {/* CTA Section */}
                <section className={classes.ctaRoot}>
                    <Box className={clsx(classes.section, classes.ctaContent)}>
                        <Typography variant="h2" className={classes.ctaHeadline}>
                            Ready to
                            <br />
                            <span className={classes.byDesign}>elevate your brand?</span>
                        </Typography>
                        <Typography className={classes.ctaSubtitle}>
                            {`The Genesis Tier is closing soon. Don't get stuck on the waitlist.`}
                        </Typography>
                        <form className={classes.form} onSubmit={handleSubmit}>
                            <CustomInput value={email} setValue={(val) => setEmail(val)} type="email" placeholder="Enter your best email..." />
                            <CustomInput value={name} setValue={(val) => setName(val)} type="text" placeholder="How we can address you?" />
                            <ContainedButton text="Apply for Genesis Status" styles={clsx(classes.primaryButton, classes.submitButtom)} />
                        </form>
                    </Box>
                </section>
            </>
            <Footer />
        </Box>
    )
}
